module.exports = __webpack_public_path__ + "static/media/Dislikehover.51e2db2e.svg";